<template>
  <main class="landing-page">
    <Hero
      v-bind="landingPageSpecs"
      :bg-image="'landing-bg.png'"
      @emit-route="getRoute($event)"
      @emit-modal="getModal($event)"
    />
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Models
import models from '../content-structure/models';

import Hero from '../../../jazz-components/src/components/UIComponents/Hero.vue';

export default {
  name: 'LandingPage',

  components: {
    Hero
  },

  computed: {
    ...mapGetters(['activeRoute']),
  },

  data() {
    return {
      landingPageSpecs: models.landing,
    };
  },

  methods: {
    ...mapActions(['getActiveRoute']),

    getRoute(e) {
      this.getActiveRoute(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-page {
  min-height: 100vh;
  min-width: 100vw;
}
</style>
